export default __webpack_public_path__ + "static/alchemy-65c67c9acf696fbde1a76ff1b90780d8.svg";